import React, {Component} from 'react';
//import ReactDOM from 'react-dom';

class Page extends Component {

  constructor(props) {
    super(props);
    this.state = {
      data: {
        content: "",
        parsed: false
        
      }
    };
    this.loadPage(this.props);
  }

  loadPage(myProps) {
    fetch('/api/page/' + myProps.match.params.page).then(res => res.json()).then(json => {
    /*  setTimeout(() => {
        this.setState({data: JSON.parse(json)});
      }, 2000) */
      this.setState({data: JSON.parse(json), parsed: true});
      //ReactDOM.findDOMNode(this.refs.hideUntil).style.opacity = 1;
    })
  }

  componentDidMount() {}

  componentWillReceiveProps(nextProps) {

    this.loadPage(nextProps);
    this.setState({parsed: false});
  //  ReactDOM.findDOMNode(this.refs.hideUntil).style.opacity = 0;

  }

  render() {
    const heading = this.state.data.heading;
    const content = this.state.data.content;
    function createMarkup() {
      return {__html: content};
    };
/*
    if (content === 0) {
      return null
    } */

    return (<section><div className="Wrapper">
      <div className="Content">

        <h2>{heading}</h2>

        <div dangerouslySetInnerHTML={createMarkup()}/></div>

    </div></section>);
  }
}

export default Page;



// WEBPACK FOOTER //
// ./src/pages/Page.js